import React, { memo } from 'react';
import Skeleton from './Skeleton';

const FormSkeleton = memo(function FormSkeleton({ fields = 4, style = {} }) {
  return (
    <div
      aria-busy="true"
      style={{
        background: '#FFFFFF',
        borderRadius: 14,
        border: '1.5px solid var(--border, #E5E7EB)',
        padding: 24,
        width: '100%',
        ...style,
      }}
    >
      <Skeleton variant="text" width={220} height={22} style={{ marginBottom: 6 }} />
      <Skeleton variant="text" width={320} height={14} style={{ marginBottom: 24 }} />

      {Array.from({ length: fields }).map((_, idx) => (
        <div key={idx} style={{ marginBottom: 20 }}>
          <Skeleton variant="text" width={110} height={12} style={{ marginBottom: 8 }} />
          <Skeleton variant="rectangular" width="100%" height={42} borderRadius={9} />
        </div>
      ))}

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
        <Skeleton variant="rectangular" width={140} height={42} borderRadius={9} />
      </div>
    </div>
  );
});

export default FormSkeleton;
